import React from 'react';
import styles from './index.module.scss';

import { ReactComponent as ProductsCatalogIcon } from 'assets/ss-icons/zero-state-icons/products-catalog.svg';

export default function NoOptions({ children = null }) {
  return (
    <div className={styles.emptyBlock}>
      <ProductsCatalogIcon />
      {children}
    </div>
  );
}
